/* eslint-disable camelcase */
// eslint-disable-next-line max-classes-per-file
import { GameBook } from './game/GameBook';

export enum Res {
  Percentage = 'percentage',
  Pixels = 'pixels',
}

export enum GameTimerType {
  CountDown = 'countdown',
  StopWatch = 'stopwatch',
}
export enum ScoreType {
  Progress = 'progress',
  Points = 'points',
}

export enum LockType {
  Code = 'code',
  Keyboard = 'keyboard',
  Sequence = 'sequence',
  PopUpTrivia = 'popUpTrivia',
  CollectItems = 'collectItems',
  Path = 'path',
}

export enum LockLocationType {
  Tag = 'tag',
  TransparentBox = 'transparentBox',
  VSItem = 'vsItem',
  Polygon = 'Polygon',
  VSImage = 'VS Image',
  VSVideo = 'VS Video',
}
export enum LockLocationTypeLabel {
  tag = 'tag',
  transparentBox = 'transparentBox',
  vsItem = 'VSitem',
}
export enum EntityType {
  Tag = 'tag',
  Sweep = 'sweep',
  Popup = 'popup',
  Polygon = 'polygon',
  VSItem = 'vsItem',
  VSImage = 'vsImage',
  VSVideo = 'vsVideo',
}
export enum ConditionType {
  HIDE = 'hide',
  REVEAL = 'reveal',
}
export enum HintContentType {
  Text = 'text',
  Picture = 'picture',
  Video = 'video',
}
export enum ContentType {
  Sound = 'sound',
  Picture = 'picture',
  Text = 'text',
  Video = 'video',
  ExperiencePopupImage = 'experiencePopupImage',
  ExperiencePopupVideo = 'experiencePopupVideo',
}
export const LOCK_SOLUTION_SEPARATOR = '|';
export const EMPTY_LOCATION_ITEM = '-1';

const DEFAULT_RES = Res.Pixels;
const DEFAULT_WIDTH = 80;
const DEFAULT_HEIGHT = 60;

export class GameGeneral {
  id: number;

  name: string;

  credits: string;

  greetingRes: Res;

  greetingImg: string;

  greetingImgW: string;

  greetingImgH: string;

  greetingImgMob: string;

  greetingImgMobW: string;

  greetingImgMobH: string;

  greetingVideo: string;

  greetingMobVideo: string;

  timerType: GameTimerType;

  limitTime: number;

  timeUpRes: Res;

  timeUpImg: string;

  timeUpImgW: string;

  timeUpImgH: string;

  timeUpImgMob: string;

  timeUpImgMobW: string;

  timeUpImgMobH: string;

  timeUpVideo: string;

  timeUpMobVideo: string;

  hint1: boolean;

  hint2: boolean;

  solution: boolean;

  nextHintTime: number;

  scoreType: ScoreType;

  scoreHint1: number;

  scoreHint2: number;

  scoreSolution: number;

  tutorialRes: Res;

  tutorialImg: string;

  tutorialImgW: string;

  tutorialImgH: string;

  tutorialImgMob: string;

  tutorialImgMobW: string;

  tutorialImgMobH: string;

  tutorialVideo: string;

  tutorialMobVideo: string;

  autoplayTutorial: boolean;

  subscriptionId: string;

  paid: boolean;

  introClip: boolean;

  introClipUrl: string;

  outroClip: boolean;

  outroClipUrl: string;

  answerIndicatorOn: boolean;

  finishScreenOn: boolean;

  timerOn: boolean;

  progressOn: boolean;

  hintsOn: boolean;

  backpackOn: boolean;

  showBackpackByDefault: boolean;

  gameBookOn: boolean;

  buttonSound: boolean;

  buttonSoundUrl: string;

  registration: boolean;

  trial: string;

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.name = model.name || null;
    this.credits = model.credits || null;
    this.greetingRes = model.greetingRes || DEFAULT_RES;
    this.greetingImg = model.greetingImg || null;
    this.greetingImgW = model.greetingImgW || DEFAULT_WIDTH;
    this.greetingImgH = model.greetingImgH || DEFAULT_HEIGHT;
    this.greetingImgMob = model.greetingImgMob || null;
    this.greetingImgMobW = model.greetingImgMobW || DEFAULT_WIDTH;
    this.greetingImgMobH = model.greetingImgMobH || DEFAULT_HEIGHT;
    this.greetingVideo = model.greetingVideo || null;
    this.greetingMobVideo = model.greetingMobVideo || null;

    this.timerType = model.timerType || GameTimerType.CountDown;
    this.limitTime = model.limitTime || 0;
    this.timeUpRes = model.timeUpRes || DEFAULT_RES;
    this.timeUpImg = model.timeUpImg || null;
    this.timeUpImgW = model.timeUpImgW || DEFAULT_WIDTH;
    this.timeUpImgH = model.timeUpImgH || DEFAULT_HEIGHT;
    this.timeUpImgMob = model.timeUpImgMob || null;
    this.timeUpImgMobW = model.timeUpImgMobW || DEFAULT_WIDTH;
    this.timeUpImgMobH = model.timeUpImgMobH || DEFAULT_HEIGHT;
    this.timeUpVideo = model.timeUpVideo || null;
    this.timeUpMobVideo = model.timeUpMobVideo || null;

    this.hint1 = model.hint1 || false;
    this.hint2 = model.hint2 || false;
    this.solution = model.solution || false;
    this.nextHintTime = model.nextHintTime || 0;

    this.scoreType = model.scoreType || ScoreType.Progress;
    this.scoreHint1 = model.scoreHint1 || 0;
    this.scoreHint2 = model.scoreHint2 || 0;
    this.scoreSolution = model.scoreSolution || 0;

    this.tutorialRes = model.tutorialRes || DEFAULT_RES;
    this.tutorialImg = model.tutorialImg || null;
    this.tutorialImgW = model.tutorialImgW || DEFAULT_WIDTH;
    this.tutorialImgH = model.tutorialImgH || DEFAULT_HEIGHT;
    this.tutorialImgMob = model.tutorialImgMob || null;
    this.tutorialImgMobW = model.tutorialImgMobW || DEFAULT_WIDTH;
    this.tutorialImgMobH = model.tutorialImgMobH || DEFAULT_HEIGHT;
    this.tutorialVideo = model.tutorialVideo || null;
    this.tutorialMobVideo = model.tutorialMobVideo || null;
    this.autoplayTutorial = model.autoplayTutorial || false;

    this.subscriptionId = model.subscriptionId || null;
    this.paid = model.paid || false;

    this.introClip = model.introClip || false;
    this.introClipUrl = model.introClipUrl || null;
    this.outroClip = model.outroClip || false;
    this.outroClipUrl = model.outroClipUrl || null;

    this.answerIndicatorOn = model.answerIndicatorOn || false;
    this.finishScreenOn = model.finishScreenOn || false;
    this.timerOn = model.timerOn || false;
    this.progressOn = model.progressOn || false;
    this.hintsOn = model.hintsOn || false;
    this.backpackOn = model.backpackOn || false;
    this.showBackpackByDefault = model.showBackpackByDefault || false;
    this.gameBookOn = model.gameBookOn || false;
    this.buttonSound = model.buttonSound || false;
    this.buttonSoundUrl = model.buttonSoundUrl || null;
    this.registration = model.registration || false;
  }
}
export class GameCondition {
  id: number;

  gameId: number;

  name: string;

  lock_ids: number[];

  conditionType: ConditionType;

  entity_type: EntityType;

  entity_ids?: string[];

  color?: string;

  teleportToSweep?: boolean;

  content_type?: ContentType;

  content_value?: string;

  gameBackpack: boolean;

  autoPlay: boolean;

  fullscreen: boolean;

  res: Res;

  resMobile: Res;

  height: number;

  width: number;

  widthMobile: number;

  heightMobile: number;

  experienceTitle: string;

  experienceDescription: string;

  lockPathId: number;

  autoClose: boolean;

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.gameId = model.gameId || null;
    this.name = model.name || null;
    this.lock_ids = model.lock_ids || null;
    this.conditionType = model.conditionType || ConditionType.REVEAL;
    this.entity_type = model.entity_type || null;
    this.entity_ids = model.entity_ids || null;
    this.color = model.color || null;
    this.teleportToSweep = model.teleportToSweep || null;
    this.content_type = model.content_type || ContentType.Text;
    this.content_value = model.content_value || null;
    this.gameBackpack = model.gameBackpack || false;
    this.autoPlay = model.autoPlay || false;
    this.fullscreen = model.fullscreen || false;
    this.res = model.res || Res.Percentage;
    this.resMobile = model.resMobile || Res.Percentage;
    this.width = model.width || 60;
    this.height = model.height || 60;
    this.widthMobile = model.widthMobile || 60;
    this.heightMobile = model.heightMobile || 60;
    this.lockPathId = model.lockPathId || null;
    this.experienceTitle = model.experienceTitle || null;
    this.experienceDescription = model.experienceDescription || null;
    this.autoClose = model.autoClose || false;
  }
}

export class GameLockQuestion {
  id: number;

  title: string;

  answer1: string;

  answer2: string;

  answer3: string;

  answer4: string;

  correctAnswer: number;

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.title = model.title || null;
    this.answer1 = model.answer1 || null;
    this.answer2 = model.answer2 || null;
    this.answer3 = model.answer3 || null;
    this.answer4 = model.answer4 || null;
    this.correctAnswer = model.correctAnswer || null;
  }
}

export enum GameLockPathTransitionType {
  FADEOUT = 'fadeout',
  FLY = 'fly',
  INSTANT = 'instant',
}

export class GameLockPath {
  id: number;

  title: string;

  description: string;

  sweepUuid: string;

  locationType: LockLocationType;

  locationItem: number | null;

  triggerType: LockLocationType;

  triggerItem: number | null;

  transitionType: GameLockPathTransitionType;

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.title = model.title || null;
    this.sweepUuid = model.sweepUuid || null;
    this.description = model.description || null;
    this.locationType = model.locationType || null;
    this.locationItem = model.locationItem ? parseInt(model.locationItem, 10) : null;
    this.triggerType = model.triggerType || null;
    this.triggerItem = model.triggerItem ? parseInt(model.triggerItem, 10) : null;
    this.transitionType = model.transitionType || GameLockPathTransitionType.INSTANT;
  }
}

export class GameLock {
  id: number;

  name: string;

  type: LockType;

  locationType: LockLocationType;

  locationItem: string;

  solution?: string;

  correctMusic?: string;

  incorrectMusic?: string;

  finishMusic?: string;

  questions?: GameLockQuestion[];

  paths?: GameLockPath[];

  keepHighlight?: boolean;

  resetHighlight?: number;

  vsRes: Res;

  vsImg?: string;

  vsImgW?: number;

  vsImgH?: number;

  vsMobImg?: string;

  vsMobImgW?: number;

  vsMobImgH?: number;

  disable?: boolean;

  icon?: string;

  hideItems?: string;

  last?: boolean;
  timerEnabled?: boolean;
  confettiEnabled?: boolean;
  lockTimer?: number;

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.name = model.name || null;
    this.type = model.type || null;
    this.locationType = model.locationType || null;
    this.locationItem = model.locationItem || null;
    this.solution = model.solution || null;
    this.correctMusic = model.correctMusic || null;
    this.incorrectMusic = model.incorrectMusic || null;
    this.finishMusic = model.finishMusic || null;
    this.questions = (model.questions && model.questions.map((question: any) => new GameLockQuestion(question))) || [];
    this.paths = (model?.paths || []).map((path: any) => new GameLockPath(path));

    this.keepHighlight = model?.keepHighlight ?? true;
    this.resetHighlight = model.resetHighlight || 0;
    this.vsRes = model.vsRes || Res.Percentage;
    this.vsImg = model.vsImg || null;
    this.vsImgW = model.vsImgW || DEFAULT_WIDTH;
    this.vsImgH = model.vsImgH || DEFAULT_HEIGHT;
    this.vsMobImg = model.vsMobImg || null;
    this.vsMobImgW = model.vsMobImgW || DEFAULT_WIDTH;
    this.vsMobImgH = model.vsMobImgH || DEFAULT_HEIGHT;
    this.disable = false;
    this.icon = model.icon || null;
    this.hideItems = model.hideItems ?? false;
    this.last = model.last ?? false;
    this.timerEnabled = model.timerEnabled ?? false;
    this.confettiEnabled = model.confettiEnabled ?? false;
    this.lockTimer = model.lockTimer ?? 0;
  }
}

export class GameHint {
  id: number;

  gameId: number;

  name: string;

  hint1_type?: HintContentType;

  hint1_value?: string;

  hint2_type?: HintContentType;

  hint2_value?: string;

  solution_type?: HintContentType;

  solution_value?: string;

  afterLock?: number;

  beforeLock?: number;

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.gameId = model.gameId || null;
    this.name = model.name || null;
    this.hint1_type = model.hint1_type || null;
    this.hint1_value = model.hint1_value || null;
    this.hint2_type = model.hint2_type || null;
    this.hint2_value = model.hint2_value || null;
    this.solution_type = model.solution_type || null;
    this.solution_value = model.solution_value || null;
    this.afterLock = model.afterLock || null;
    this.beforeLock = model.beforeLock || null;
  }
}
export class Game extends GameGeneral {
  id: number;

  locks: GameLock[];

  hints: GameHint[];

  conditions: GameCondition[];

  book: GameBook;

  paths: GameLock;

  constructor(model: any = {}) {
    super(model);
    this.id = model.id || null;
    this.locks = (model.locks?.length && model.locks.filter((lock) => lock.type !== LockType.Path).map((lock: any) => new GameLock(lock))) || [];
    const paths = (model?.locks || []).find((lock) => lock.type === LockType.Path);
    this.paths = paths ? new GameLock(paths) : null;
    this.hints = (model.hints && model.hints.map((hint: any) => new GameHint(hint))) || [];
    this.conditions = (model.conditions && model.conditions.map((condition: any) => new GameCondition(condition))) || [];
    this.book = model.book ? new GameBook(model.book) : null;
  }
}
